import { phpRequest } from "./phpRequest";
import localforage from 'localforage';
import {nubisGorequest} from '@/apis/nubisGorequest';
// 用户相关API
const UserManagementApi = {
  // 获取公司列表
  GetCompanyTree : async () => {
    const company_id = await localforage.getItem("userCompanyID");
    return phpRequest.get("/company-tree",{
      company_id: company_id
    })
  },

  GetGroupTreeListApi : async (company_id) => {
    const res = await phpRequest.get('/groups/tree',{
      company_id: company_id
    })
    return res;
  },
  // 获取用户列表
  GetList(params, config) {
    return nubisGorequest.post("/fec/nubis/v3/get_user_list", params, config);
  },
  // 归属和移除门店
  UpdateUserInvisibleStore(params) {
    return nubisGorequest.post("/fec/nubis/v3/update_user_invisible_group", params);
  },
  // 获取角色
  GetRoleList(params) {
    return nubisGorequest.post("/fec/nubis/v3/get_role_list", params);
  }

}
export default UserManagementApi
